import { registerComponent, createMessage } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "back-in-stock",
  class BackInStock extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");

      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    getSubscription() {
      const data = new FormData(this.form);

      return {
        email: data.get("email")?.trim(),
        phoneNumber: data.get("phone")?.trim(),
        variantId: data.get("id"),
      };
    }

    handleSubmit(event) {
      const subscription = this.getSubscription();

      event.preventDefault();

      if (
        subscription.phoneNumber &&
        !this.isValidPhoneNumber(subscription.phoneNumber)
      ) {
        createMessage(WYATT.t.backInStock.phoneNumberInvalidFormat, {
          type: "error",
          appendPoint: "[data-message-container]",
          dismiss: false,
        });
        return;
      }

      this.createBackInStockSubscription(subscription);

      this.close();
      createMessage(WYATT.t.backInStock.successMessage, { type: "success" });
    }

    close() {
      this.closest("dialog").close();
    }

    isValidPhoneNumber(phoneNumber) {
      const e164Regex = /^\+\d{10,15}$/;
      return e164Regex.test(phoneNumber);
    }

    createBackInStockSubscription(subscription) {
      const PUBLIC_KEY = "UJ6uVH";

      const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${PUBLIC_KEY}`;

      const profileAttributes = {
        email: subscription.email,
        ...(subscription.phoneNumber
          ? { phone_number: subscription.phoneNumber }
          : {}),
      };

      const channels = ["EMAIL", ...(subscription.phoneNumber ? ["SMS"] : [])];

      const options = {
        method: "POST",
        headers: {
          accept: "application/vnd.api+json",
          revision: "2025-01-15",
          "content-type": "application/vnd.api+json",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: profileAttributes,
                },
              },
              channels,
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${subscription.variantId}`,
                },
              },
            },
          },
        }),
      };

      fetch(url, options);
    }
  },
);
